import { sendWebinarAnalytics } from './analytics.js';

/**
 * Webinar pages
 */

(function ($) {
	/**
	 * Form handling
	 */
	const webinarForm = document.getElementById('webinar-form');
	const webinarSessionDates = document.querySelectorAll('.webinar-session-dates');
	const redirectUrl = webinarForm.dataset.redirectUrl;


	/**
	 * Grab a cookie
	 * @param {string} cname Cookie name
	 * @returns Cookie value
	 */
	const getCookie = (cname) => {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	/**
	 * What the visitor sees for each registration outcome (WEB-03). The same
	 * outcome is sent to HubSpot as webinar_status.
	 */
	const statusMessage = (status, topic) => {
		switch (status) {
			case 'registered':
				return (topic ? "You're registered for " + topic + '.' : "You're registered.") + ' Check your inbox for the join link.';
			case 'already_registered':
				return "You're already registered. Check your inbox for the join link from Zoom.";
			case 'closed':
				return 'Registration for this session has closed.';
			default:
				return "We couldn't complete your Zoom registration, but we've got your details and the team will send you the link.";
		}
	};

	const submitHsForm = (userObj, finalMessage, registrationStatus, joinUrl) => {
		console.log('Starting HS Form');
		// Grab some needed form variables
		const formId = webinarForm.dataset.formId;
		const meetingId = webinarForm.dataset.meetingId;
		const portalId = webinarForm.dataset.portalId;
		const userIp = webinarForm.dataset.userIp;

		// We are also going to try and grab some marketing variables
		const hsCookie = getCookie('hubspotutk');

		// Build out the form fields
		const formBody = {
			fields: [
				{
					objectTypeId: "0-1",
					name: "firstname",
					value: userObj.first_name
				},
				{
					objectTypeId: "0-1",
					name: "lastname",
					value: userObj.last_name
				},
				// {
				// 	objectTypeId: "0-1",
				// 	name: "company",
				// 	value: 'Hubspot'
				// },
				{
					objectTypeId: "0-1",
					name: "email",
					value: userObj.email
				},
				// {
				// 	objectTypeId: "0-1",
				// 	name: "session_attending",
				// 	value: userObj.sessionDates
				// },
				// {
				// 	objectTypeId: "0-1",
				// 	name: "which_business_systems",
				// 	value: userObj.custom_questions[0].answer
				// },
			],
			context: {
				pageUri: window.location.href,
				pageName: document.title,
				ipAddress: userIp
			}
		}

		// The Zoom outcome, so a failed registration is still a lead (WEB-03). The
		// replay-redirect path skips Zoom and sends no status.
		if (registrationStatus) {
			formBody.fields.push({
				objectTypeId: "0-1",
				name: "webinar_status",
				value: registrationStatus
			});
		}

		// The registrant's own Zoom join link, for the reminder email (WEB-22). Each
		// webinar names its own HubSpot property, so a contact registered for two
		// webinars keeps both links.
		const joinLinkProperty = webinarForm.dataset.joinLinkProperty;
		if (registrationStatus === 'registered' && joinUrl && joinLinkProperty) {
			formBody.fields.push({
				objectTypeId: "0-1",
				name: joinLinkProperty,
				value: joinUrl
			});
		}

		// A page-only question (WEB-24) and its follow-up (WEB-25) each name their own
		// HubSpot property. Answers go to HubSpot only, never to Zoom.
		webinarForm.querySelectorAll('[data-hs-property]').forEach((field) => {
			const value = field.value.trim();
			if (value) {
				formBody.fields.push({
					objectTypeId: "0-1",
					name: field.dataset.hsProperty,
					value: value
				});
			}
		});

		// We only add the HS cookie if it exists
		if (hsCookie) {
			formBody.context.hutk = hsCookie;
		}

		console.log('hubspot submission: ', formBody, portalId, formId);

		// Now we submit
		$.ajax({
			type: 'POST',
			url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
			dataType: "html",
			contentType: "application/json",
			data: JSON.stringify(formBody),
			success: function (res) {
				// Save the response
				console.log('Form submit: ', res);
				// Get some elements
				const formLoader = document.getElementById('webinar-loader');
				const formMessageWrapper = document.getElementById('webinar-message-wrapper');
				const formMessage = document.getElementById('webinar-message');
				formLoader.classList.remove('flex');
				formLoader.classList.add('hidden');
				formMessageWrapper.classList.remove('hidden');
				formMessageWrapper.classList.add('flex');

				// Print the final message
				formMessage.innerHTML = finalMessage;

				// Run the Google Tag manager event
				sendWebinarAnalytics('Webinar Registration', {
					first_name: userObj.first_name,
					last_name: userObj.last_name,
					email: userObj.email,
					meeting_id: meetingId
				});

				//redirect after sending analytics, wait one second to allow analytics to process
				setTimeout(() => {
					if (redirectUrl) {
						console.log('Redirecting to: ', redirectUrl);
						window.location.href = redirectUrl;
					}
				}, 1000);
			},
			error: function (error) {
				console.log('Form error: ', error);
				let errorMessage = 'There was an error registering for the webinar, please ensure you are using a company or valid email and try again'

				handleError(errorMessage);

			}
		});
	}

	const handleError = (message) => {
		alert(message);
		const formLoader = document.getElementById('webinar-loader');
		formLoader.classList.add('hidden');

		const formMessage = document.getElementById('webinar-message');
		const formElement = document.getElementById('webinar-form-wrapper');
		const formMessageWrapper = document.getElementById('webinar-message-wrapper');
		formElement.classList.remove('hidden');
		formMessageWrapper.classList.remove('hidden');
		formMessageWrapper.classList.add('flex');
		// formMessage.innerHTML = message;
	}


	/**
	 * Register a user in Zoom
	 * @param {object} userObj Object from the form values
	 * @param {string} occurrences Occurrences IDs from the select
	 * @returns {object}
	 */
	const registerUser = (userObj) => {
		// Grab the form wrapper and meeting ID
		const formWrapper = document.getElementById('webinar-form');
		const meetingId = formWrapper.dataset.meetingId;

		// Check for the meeting ID
		if (!meetingId) return;

		//if redirect URL is set, skip zoom registration and go directly to HS form submission
		if (redirectUrl) {
			console.log('Redirect URL found, skipping Zoom registration:', redirectUrl);
			let userObjSessions = userObj;
			userObjSessions.sessionsReadable = [];
			console.log('Skipping Zoom registration, submitting HS form directly with:', userObjSessions);
			submitHsForm(userObjSessions, 'Redirecting to video page...');
			return;
		}

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'coefficient_register_webinar',
				userInfo: JSON.stringify(userObj),
				meetingId: meetingId
			},
			success: function (res) {
				console.log('res: ', res);

				// Whatever comes back (an empty body, invalid JSON, a Zoom error),
				// the visitor still goes to HubSpot, with the outcome (WEB-03).
				let response = null;
				try {
					response = res ? JSON.parse(res) : null;
				} catch (err) {
					console.warn('Could not parse the registration response: ', err);
				}

				const status = (response && response.registration_status) || 'error';
				const topic = response && response.data && response.data.topic;
				const joinUrl = response && response.data && response.data.join_url;

				let userObjSessions = userObj;
				userObjSessions.sessionsReadable = [];

				submitHsForm(userObjSessions, statusMessage(status, topic), status, joinUrl);
			},
			error: function (xhr) {
				// Status 0: the request never reached our server, usually the
				// visitor's own connection, so HubSpot is unreachable too. Let them retry.
				if (!xhr || xhr.status === 0) {
					handleError("We couldn't reach the server. Check your connection and try again.");
					return;
				}

				// Our server failed (500, timeout …): HubSpot is a separate service,
				// so the lead still goes through, as an error.
				let userObjSessions = userObj;
				userObjSessions.sessionsReadable = [];
				submitHsForm(userObjSessions, statusMessage('error'), 'error');
			}
		});
	}


	// The follow-up shows only for the answer it asks about, and is cleared when
	// hidden so a changed answer doesn't send it (WEB-25)
	const extraQuestion = document.getElementById('webinar-extra-question');
	const extraFollowUp = document.getElementById('webinar-extra-follow-up');
	if (extraQuestion && extraFollowUp) {
		extraQuestion.addEventListener('change', () => {
			const show = extraQuestion.value === extraFollowUp.dataset.showWhen;
			extraFollowUp.classList.toggle('hidden', !show);
			if (!show) {
				extraFollowUp.querySelector('input').value = '';
			}
		});
	}

	// Detect the form submit
	if (webinarForm) {
		webinarForm.addEventListener('submit', (event) => {
			// Stop a refresh
			event.preventDefault();

			// Grab the values
			const formElement = document.getElementById('webinar-form-wrapper');
			const formLoader = document.getElementById('webinar-loader');
			const $form = $('#webinar-form');
			formElement.classList.add('hidden');
			formLoader.classList.remove('hidden');
			formLoader.classList.add('flex');

			const userObj = {
				first_name: $form.find('input[name="firstname"]').val(),
				last_name: $form.find('input[name="lastname"]').val(),
				email: $form.find('input[name="email"]').val(),
				// org: $form.find('input[name="company"]').val(),
				// custom_questions: [
				// 	{
				// 		title: "Which business systems are you looking to sync with Google Sheets?",
				// 		answer: $form.find('input[name="system"]').val()
				// 	}
				// ],
				language: "en-US",
				sessions: $form.find('select[name="session"]').val(),
				sessionDates: $form.find('select[name="session"] option:selected').text(),
				auto_approve: true
			}

			registerUser(userObj, userObj.sessions);
		});
	}


	/**
	 * Convert PHP date to a local timezone date
	 * @param {*} options Select options with a date string in innerHTML
	 */
	const convertSelectDates = (options) => {
		// Loop the options
		const timezone = moment.tz.guess();

		options.forEach((option) => {
			const date = moment.tz(option.innerHTML, timezone).format('MMMM Do, YYYY - H:mma z');
			option.innerHTML = date;
		});
	}

	convertSelectDates(webinarSessionDates);

	/**
	 * Swiper handling
	 */
	const webinarSliderWrapper = document.getElementById('webinar-slider');

	if (webinarSliderWrapper) {
		const webinarSlider = new Swiper('#webinar-slider', {
			slidesPerView: 1,
			loop: false,
			spaceBetween: 60,
			pagination: {
				el: '.slider-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	}
}(jQuery));